<template>
  <div style="padding: 20px 20px 20px 0; display: flex">
    <table border="1" style="border-collapse: collapse">
      <tr>
        <td class="tdStyle"></td>
        <td class="tdStyle">
          <el-date-picker
            clearable
            size="small"
            v-model="queryDate1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="queryData1"
          >
          </el-date-picker>
        </td>
      </tr>
      <tr>
        <td class="tdStyle">总</td>
        <td class="tdStyle2">{{ amountEnergy1 }}</td>
      </tr>
      <tr>
        <td class="tdStyle">A</td>
        <td class="tdStyle2">{{ aEnergy1 }}</td>
      </tr>
      <tr>
        <td class="tdStyle">B</td>
        <td class="tdStyle2">{{ bEnergy1 }}</td>
      </tr>
      <tr>
        <td class="tdStyle">C</td>
        <td class="tdStyle2">{{ cEnergy1 }}</td>
      </tr>
      <tr>
        <td class="tdStyle">商铺用水量</td>
        <td class="tdStyle2">{{ shopWater1 }}</td>
      </tr>
      <tr>
        <td class="tdStyle">公寓用水量</td>
        <td class="tdStyle2">{{ apartmentWater1 }}</td>
      </tr>
    </table>

    <table border="1" style="border-collapse: collapse; margin-left: 20px">
      <tr>
        <td class="tdStyle">
          <el-date-picker
            clearable
            size="small"
            v-model="queryDate2"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="queryData2"
          >
          </el-date-picker>
        </td>
        <td class="tdStyle">差额</td>
      </tr>
      <tr>
        <td class="tdStyle2">{{ amountEnergy2 }}</td>
        <td class="tdStyle">
          {{
            amountEnergy1 - amountEnergy2 > 0
              ? amountEnergy1 - amountEnergy2
              : 0 - (amountEnergy1 - amountEnergy2)
          }}
        </td>
      </tr>
      <tr>
        <td class="tdStyle2">{{ aEnergy2 }}</td>
        <td class="tdStyle">
          {{ aEnergy1 - aEnergy2 > 0 ? aEnergy1 - aEnergy2 : 0 - (aEnergy1 - aEnergy2) }}
        </td>
      </tr>
      <tr>
        <td class="tdStyle2">{{ bEnergy2 }}</td>
        <td class="tdStyle">
          {{ bEnergy1 - bEnergy2 > 0 ? bEnergy1 - bEnergy2 : 0 - (bEnergy1 - bEnergy2) }}
        </td>
      </tr>
      <tr>
        <td class="tdStyle2">{{ cEnergy2 }}</td>
        <td class="tdStyle">
          {{ cEnergy1 - cEnergy2 > 0 ? cEnergy1 - cEnergy2 : 0 - (cEnergy1 - cEnergy2) }}
        </td>
      </tr>
      <tr>
        <td class="tdStyle2">{{ shopWater2 }}</td>
        <td class="tdStyle">
          {{
            shopWater1 - shopWater2 > 0
              ? shopWater1 - shopWater2
              : 0 - (shopWater1 - shopWater2)
          }}
        </td>
      </tr>
      <tr>
        <td class="tdStyle2">{{ apartmentWater2 }}</td>
        <td class="tdStyle">
          {{
            apartmentWater1 - apartmentWater2 > 0
              ? apartmentWater1 - apartmentWater2
              : 0 - (apartmentWater1 - apartmentWater2)
          }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import publicExport from "../../../assets/js/publicExport.js";
export default {
  data() {
    return {
      loading: false,
      queryDate1: [],
      queryDate2: [],
      amountEnergy1: 0, // 总用电量
      aEnergy1: 0, //  A栋用电量
      bEnergy1: 0, //  B栋用电量
      cEnergy1: 0, //  C栋用电量
      shopWater1: 0, //  商铺用水量
      apartmentWater1: 0, //  公寓用水量

      amountEnergy2: 0, // 总用电量
      aEnergy2: 0, //  A栋用电量
      bEnergy2: 0, //  B栋用电量
      cEnergy2: 0, //  C栋用电量
      shopWater2: 0, //  商铺用水量
      apartmentWater2: 0, //  公寓用水量
    };
  },
  methods: {
    queryData1() {
      let query = {
        startTime: "",
        endTime: "",
      };
      if (this.queryDate1 && this.queryDate1.length == 2) {
        query.startTime = this.queryDate1[0];
        query.endTime = this.queryDate1[1];
      }
      this.$http.post(`/api/energy/getEnergyStatement`, { ...query }).then((res) => {
        if (res.data.code == 0) {
          this.amountEnergy1 = res.data.data.amountEnergy;
          this.aEnergy1 = res.data.data.aEnergy;
          this.bEnergy1 = res.data.data.bEnergy;
          this.cEnergy1 = res.data.data.cEnergy;
          this.shopWater1 = res.data.data.shopWater;
          this.apartmentWater1 = res.data.data.apartmentWater;
        } else {
          this.$message.error("查询失败");
        }
      });
    },
    queryData2() {
      let query = {
        startTime: "",
        endTime: "",
      };
      if (this.queryDate2 && this.queryDate2.length == 2) {
        query.startTime = this.queryDate2[0];
        query.endTime = this.queryDate2[1];
      }
      this.$http.post(`/api/energy/getEnergyStatement`, { ...query }).then((res) => {
        if (res.data.code == 0) {
          this.amountEnergy2 = res.data.data.amountEnergy;
          this.aEnergy2 = res.data.data.aEnergy;
          this.bEnergy2 = res.data.data.bEnergy;
          this.cEnergy2 = res.data.data.cEnergy;
          this.shopWater2 = res.data.data.shopWater;
          this.apartmentWater2 = res.data.data.apartmentWater;
        } else {
          this.$message.error("查询失败");
        }
      });
    },
  },
  mounted() {},
};
</script>

<style scoped="scoped">
.tdStyle {
  padding: 5px 10px;
  width: 150px;
  height: 30px;
}

.tdStyle2 {
  padding: 5px 10px;
  width: 150px;
  height: 30px;
  text-align: center;
}
</style>
